var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("scenario-selection-confirmation-popup", {
        ref: "confirmationPopup",
        attrs: { scenarios: _vm.selectedScenarios },
        on: { confirm: _vm.navigateToSelectedScenarioTemplatesPage }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-3 form-group" },
        [
          _vm.divisionList
            ? _c("division-dropdown", {
                attrs: {
                  "division-list": _vm.divisionList,
                  value: _vm.divisionId
                },
                on: {
                  input: function($event) {
                    return _vm.selectDivisionId($event)
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 form-group" }, [
        _c("div", { staticClass: "box" }, [
          _c(
            "div",
            { staticClass: "box-body" },
            [
              _c("scenario-list", {
                attrs: { scenarios: _vm.scenarios },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var scenario = ref.scenario
                      return [
                        _c("scenario-list-item", {
                          key: scenario.id,
                          attrs: { scenario: scenario },
                          on: {
                            "scenario-selection-changed": function($event) {
                              return _vm.onScenarioSelectionChanged(
                                scenario.id,
                                $event
                              )
                            }
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _vm.canWrite
                ? _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 form-group text-right" }, [
                      _vm.hasSelectedScenarios
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-lg btn-primary",
                              on: { click: _vm.showConfirmationPopup }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.resource(
                                      "DmVisualizer_Index_SelectionConfirmationPopup_Title"
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  ])
                : _vm._e()
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }